<mat-dialog-content>

    <div class="row">
    <div class="col-sm-6">
        <mat-card>
            <mat-card-title class="font-weight-bold caption-color"><b>Rental EMI Detail (For Sales Booking)</b></mat-card-title>
            <mat-divider></mat-divider>
            
            <mat-card-content class="pt-2">
                


                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group row text-left">
                            <label  class="col-sm-8 col-form-label">Total Rental Amount</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                        {{spraRentalEmiModel.EmiDetailWithOutFreeCopy.TotalRentalAmount}}
                                </div>
        
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group row text-left">
                            <label  class="col-sm-8 col-form-label">Loan amount</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    {{spraRentalEmiModel.EmiDetailWithOutFreeCopy.LoanAmount}}
                                </div>
        
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group row text-left">
                            <label  class="col-sm-8 col-form-label">Rate of Interest (monthly)</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    {{spraRentalEmiModel.EmiDetailWithOutFreeCopy.RateOfInterest}} %
                                </div>
        
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group row text-left">
                            <label  class="col-sm-8 col-form-label">Term (in months)</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    {{spraRentalEmiModel.EmiDetailWithOutFreeCopy.LockInMonths}}
                                </div>
        
                            </div>
                        </div>
                    </div>

                    
                    <div class="col-sm-6">
                        <div class="form-group row text-left">
                            <label  class="col-sm-8 col-form-label">EMI (monthly rest)</label>
                            <div class="col-sm-4">
                                <div class="input-group">
                                    {{spraRentalEmiModel.EmiDetailWithOutFreeCopy.EMI}}
                                </div>
        
                            </div>
                        </div>
                    </div>
                   

<div class="col-sm-12">

    <table class="table">
        <thead>
            <tr>
                <th>Months</th>
                <th>Opening</th>
                <th>Interest</th>
                <th>Principal</th>
                <th>Closing</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of spraRentalEmiModel.EmiDetailWithOutFreeCopy.SpraEmiChart; let i = index;">
                <td>{{item.Months}}</td>
                <td>{{item.Opening}}</td>
                <td>{{item.Interest}}</td>
                <td>{{item.Principal}}</td>
                <td>{{item.Closing}}</td>
            </tr>
        </tbody>
    </table>

</div>

                    </div>

                        
            </mat-card-content>
    
    
    </mat-card> 
    </div>
    
     
    
        <div class="col-sm-6">
            <mat-card>
                <mat-card-title class="font-weight-bold caption-color"><b>Rental EMI Detail (For Monthly Accounting Entry (Incl Service Free Copy))</b></mat-card-title>
                <mat-divider></mat-divider>
                
                <mat-card-content class="pt-2">
                    
    
    
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group row text-left">
                                <label  class="col-sm-8 col-form-label">Total Rental Amount</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                            {{spraRentalEmiModel.EmiDetailWithFreeCopy.TotalRentalAmount}}
                                    </div>
            
                                </div>
                            </div>
                        </div>
    
                        <div class="col-sm-6">
                            <div class="form-group row text-left">
                                <label  class="col-sm-8 col-form-label">Loan Amount</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        {{spraRentalEmiModel.EmiDetailWithFreeCopy.LoanAmount}}
                                    </div>
            
                                </div>
                            </div>
                        </div>
    
                        <div class="col-sm-6">
                            <div class="form-group row text-left">
                                <label  class="col-sm-8 col-form-label">Rate of Interest (monthly)</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        {{spraRentalEmiModel.EmiDetailWithFreeCopy.RateOfInterest}} %
                                    </div>
            
                                </div>
                            </div>
                        </div>
    
                        <div class="col-sm-6">
                            <div class="form-group row text-left">
                                <label  class="col-sm-8 col-form-label">Term (in months)</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        {{spraRentalEmiModel.EmiDetailWithFreeCopy.LockInMonths}}
                                    </div>
            
                                </div>
                            </div>
                        </div>
    
                        
                        <div class="col-sm-6">
                            <div class="form-group row text-left">
                                <label  class="col-sm-8 col-form-label">EMI (monthly rest)</label>
                                <div class="col-sm-4">
                                    <div class="input-group">
                                        {{spraRentalEmiModel.EmiDetailWithFreeCopy.EMI}}
                                    </div>
            
                                </div>
                            </div>
                        </div>
                       
                        <div class="col-sm-12">

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Months</th>
                                        <th>Opening</th>
                                        <th>Interest</th>
                                        <th>Principal (M/C)</th>
                                        <th>Principal</th>
                                        <th>Closing</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of spraRentalEmiModel.EmiDetailWithFreeCopy.SpraEmiChart; let i = index;">
                                        <td>{{item.Months}}</td>
                                        <td>{{item.Opening}}</td>
                                        <td>{{item.Interest}}</td>
                                        <td>{{item.PrincipalMC}}</td>
                                        <td>{{item.Principal}}</td>
                                        <td>{{item.Closing}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        
                        </div>
                        

                        </div>
    
                            
                </mat-card-content>
        
        
        </mat-card> 
        </div>
    
    </div>


    </mat-dialog-content>